
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import { GetServerSideProps } from "next";
import { PageMeComp, ssrMe } from "src/generated/page";
import Authorization from "src/components/Authorization/Auhtorization";
import useTranslation from 'next-translate/useTranslation';

 const _getServerSideProps: GetServerSideProps = async (ctx) => {
  const { props } = await ssrMe.getServerPage({}, ctx, true);

  if (props.data.pilotMe) {
    return {
      redirect: {
        destination: "/pilot/dashboard",
        permanent: true,
      },
    };
  }
  return { props };
};

const SignUp: PageMeComp = () => {
  const { t } = useTranslation('pages/signUp');

  return <Authorization header={t('register')} />;
};

export default SignUp;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/sign-up',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  